import { useDeviceType } from '@hooks/useDeviceType'
import { ISelectCompanies } from './types'

import imgEmty from '@img/empty.svg'
import { IconClearClose, IconEntity, IconQuestion, IconSearch } from '@img/icons'

import { Empty, Flex, ToolTip, Pagination, Loader, Input, Drawer, Divider, Button, Table, Container } from '@ui/index'
import css from './ui.module.scss'

/** Выбор контрагента */
export const SelectCompanies = ({
    isOpen, handlerButtonOk, handlerButtonCancel,
    isLoading, totalCount, pageSize, companiesList, 
    txtSearch, txtSearchOnChange, currentPageNumber,
    handleOpenCardCompany,
}: ISelectCompanies) => {
    const deviceType = useDeviceType()
    
    return <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
        <Flex className='drawer_container'>
            <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                <header>
                    <Flex gap='4px' flexDirection='row' alignItems='center'>
                        <IconEntity color='#fff' width='20px' height='20px' />
                        <h4>Выбор контрагента</h4>
                    </Flex>
                </header>

                <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='drawer_container-body'>
                <Loader isOpen={isLoading} backdrop title="Загрузка..." />

                <Flex gap='6px' className='drawer_container-content' overflowY='hidden' padding='2px 0px 0px 0px'>
                    <Flex gap='4px' flexDirection='row' justifyContent='space-between'>
                        <Input size="md" placeholder="Поиск..." paddingLeft='6px' paddingRight='6px' width='100%'
                            value={txtSearch.value} onChange={(e) => txtSearchOnChange(e.target.value)}
                            prefix={<IconSearch width='16px' height='16px' color="var(--foreground_accent_default)" />}
                            suffix={<>
                                {txtSearch.value && <Button id='tooltipBtnClear' size="xs" variant="icon" onClick={() => txtSearchOnChange('')}><IconClearClose width='18px' height='18px' /></Button>}
                                
                                <ToolTip placement='bottomRight' title={<>Поиск по:<br/>🗸 Фамилии<br/>🗸 Имени<br/>🗸 Отчеству<br/>🗸 ИНН<br/>🗸 КПП<br/>🗸 Наименованию полному<br/>🗸 Наименованию короткому<br/>🗸 Адресу<br/>🗸 Реквизитам</>}>
                                    <IconQuestion width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} color="var(--foreground_accent_default)" />
                                </ToolTip>
                            </>}
                        />

                        <Button size="md" variant="primary" padding='0 10px' onClick={() => handleOpenCardCompany(true, 'new')}>СОЗДАТЬ</Button>
                    </Flex>

                    <Divider />

                    <Table.Content>
                        {!companiesList.length 
                            ? <Empty image={imgEmty} title='Контрагенты отсутствуют' /> 
                            : companiesList.map((item) => (
                                <Table.Row key={item.companyID} onClick={() => handlerButtonOk && handlerButtonOk(item.companyID, item.companyNameShort, item.address, item.companyINN)}>
                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <p>{item.companyName}</p>
                                        <Flex gap='5px' flexDirection='row'><p style={{opacity: '.8', color: `${item.companyINN.length > 12 && 'red'}`}}>{item.companyINN}</p> / <p style={{ opacity: '.8' }}>{item.companyKPP || '----'}</p></Flex>
                                    </div>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>

                    <Container className={css['footer']}>
                        <Pagination totalCount={totalCount} pageSize={pageSize} currentPage={currentPageNumber.value} onChange={(e) => currentPageNumber.setValue(e)} />
                    </Container>
                </Flex>
            </Flex>
        </Flex>

        {/* <ToolTip anchorSelect="#tooltipBtnClose" content='Закрыть' place="bottom-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnCreate" content='Создать нового контрагента' place="bottom-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnSearchInfo" place="bottom-end">Поиск по:<br/>🗸 Фамилии<br/>🗸 Имени<br/>🗸 Отчеству<br/>🗸 ИНН<br/>🗸 КПП<br/>🗸 Наименованию полному<br/>🗸 Наименованию короткому<br/>🗸 Адресу<br/>🗸 Реквизитам</ToolTip> */}
    </Drawer>
}